<template>
  <div>
  
    <!-- 弹框主体 -->
    <el-dialog
      title="查看详情"
      :visible.sync="isDialog"
      width="1000px"
      :close-on-click-modal="false"
      class="detail-dialog"
    >
      <!-- 表格形式的详情内容 -->
      <el-table
        :data="tableData"
        border
        :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
        :cell-style="{ padding: '12px 15px' }"
      >
        <el-table-column
          prop="label"
          label=""
          width="160"
          align="center"
        />
        <el-table-column
          prop="value"
          label=""
          align="left"
        />
      </el-table>

      <!-- 底部按钮 -->
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSave">保存</el-button>
        <el-button @click="isDialog = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "DetailDialog",
    props: {
    isDialog: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    isView: {
      type: Boolean,
      default: false,
    },
    editData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      dialogVisible: false,
      // 表格数据，完全还原图片内容
      tableData: [
        {
          label: "培训项目名称",
          value: "新媒体运营与短视频实战技能培训"
        },
        {
          label: "培训项目等级",
          value: "五级"
        },
        {
          label: "项目简介",
          value: `本项目聚焦当下新媒体行业实用需求，专为职场人士、创业者、转行从业者及内容爱好者打造，以实战落地、即学即用为核心，摒弃纯理论教学，全面覆盖新媒体运营全流程与短视频创作核心技能。
培训围绕账号定位、内容策划、文案撰写、拍摄剪辑、流量运营、粉丝转化、数据分析等关键环节展开，结合主流平台规则与最新流量逻辑，通过案例拆解、实操演练、现场改稿、作品复盘等方式，系统教授爆款内容打造方法、短视频拍摄技巧、剪辑工具实操、直播运营基础、私域引流与商业变现路径。
课程兼顾零基础入门与进阶提升，从工具使用到运营思维，从内容创作到流量增长，帮助学员快速掌握可直接应用于工作的实战能力，有效提升个人职场竞争力，助力企业实现品牌曝光、用户增长与业绩转化，打造具备独立操盘新媒体账号与短视频项目的专业运营人才。`
        }
      ]
    };
  },
  methods: {
    handleSave() {
      // 模拟保存操作
      // this.$message.success("保存成功");
      this.isDialog = false;
    }
  }
};
</script>

<style scoped>
/* 自定义弹框样式，还原蓝色标题栏 */
.detail-dialog >>> .el-dialog__header {
  background-color: #409eff;
  color: #fff;
  padding: 0 20px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.detail-dialog >>> .el-dialog__title {
  color: #fff;
  font-size: 16px;
  font-weight: normal;
}
.detail-dialog >>> .el-dialog__headerbtn {
  color: #fff;
  font-size: 18px;
  top: 15px;
}
.detail-dialog >>> .el-dialog__body {
  padding: 20px;
}
/* 表格单元格换行处理 */
.detail-dialog >>> .el-table .cell {
  white-space: pre-wrap;
  line-height: 1.6;
}
.dialog-footer {
  text-align: center;
  padding: 15px 0;
}
</style>